import { createSelector, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { authApi } from '~services/api/auth';
import type { TAuthUserInfo } from '~services/api/auth/types';
import { TokenManager } from '~shared/services/ClientTokenManager';

import type { RootState } from '../index';

type AuthState = {
	info: TAuthUserInfo;
};
const initialState: AuthState = {
	info: {
		id: '',
		email: '',
		roles: [],
		isSafe: false,
	},
};
const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addMatcher(
				authApi.endpoints.register.matchFulfilled,
				(state, action) => {
					state.info.email = action.meta.arg.originalArgs.email;
				}
			)
			.addMatcher(
				authApi.endpoints.registerGoogle.matchFulfilled,
				(state, action) => {
					state.info.email = action.payload.email;
				}
			)
			.addMatcher(
				isAnyOf(
					authApi.endpoints.register.matchFulfilled,
					authApi.endpoints.registerGoogle.matchFulfilled
				),
				(state) => {
					state.info.roles = state.info.roles.filter((role) => role !== 'demo');
				}
			)
			.addMatcher(
				isAnyOf(
					authApi.endpoints.login.matchFulfilled,
					authApi.endpoints.googleLogin.matchFulfilled,
					authApi.endpoints.authenticate.matchFulfilled
				),
				(state, action) => {
					if (action.meta) {
						const meta = action.meta.baseQueryMeta;

						// @ts-ignore
						const token: string = meta?.response?.headers?.get('X-token');// eslint-disable-line
						if (token) {
							TokenManager.saveToken(token);
						}
					}
					state.info.id = action.payload.id;
					state.info.isSafe = action.payload.isSafe;
					state.info.email = action.payload.email;
					state.info.roles = action.payload.roles ?? [];
				}
			)
			.addMatcher(
				authApi.endpoints.updateSafeMode.matchFulfilled,
				(state, action) => {
					state.info.isSafe = action.meta.arg.originalArgs.isSafeMode;
				}
			)
			.addMatcher(
				authApi.endpoints.changeEmail.matchFulfilled,
				(state, action) => {
					state.info.email = action.meta.arg.originalArgs.email;
				}
			);
	},
});
const userAuthInfo = (state: RootState) => state.auth.info;
const userRoles = (state: RootState) => state.auth.info.roles;
export const getUserId = createSelector(userAuthInfo, (info) => info.id);
export const getUserEmail = createSelector(userAuthInfo, (info) => info.email);
export const getIsDemoUser = createSelector(userRoles, (roles) =>
	roles.includes('demo')
);
export const getIsSafeMode = createSelector(
	userAuthInfo,
	(info) => info.isSafe
);
export const getIsCreator = createSelector(userRoles, (roles) =>
	roles.includes('digital.duplicate')
);

export default authSlice.reducer;
